import React from 'react';
import {Backdrop, CircularProgress} from "@mui/material";

const LoadingOverlay = ({open, title}) => {
    return (
        <Backdrop
            sx={(theme) => ({color: '#eee', zIndex: theme.zIndex.drawer + 1})}
            open={open}
        >
            <div style={{textAlign: 'center'}}>
                <CircularProgress color="inherit" size="80px"/>
                <p style={{marginTop: "10px", fontFamily: "Roboto, Helvetica, Arial, sans-serif", fontSize: "20px"}}>
                    {title}
                </p>
            </div>

        </Backdrop>
    );
};

export default LoadingOverlay;